"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerConfigurableListLoader = registerConfigurableListLoader;
const ConfigurableListLoader_1 = require("./ConfigurableListLoader");
const registerDataListLoader_1 = require("./registerDataListLoader");
async function registerConfigurableListLoader(app, entity) {
    const configurableListLoader = new ConfigurableListLoader_1.ConfigurableListLoader(app, entity);
    (0, registerDataListLoader_1.registerDataListLoader)('dataListValues', configurableListLoader);
    (0, registerDataListLoader_1.registerDataListLoader)('dataListQuestions', configurableListLoader);
}
